import getScopedPath from 'owa-url/lib/getScopedPath';
import handleAuthErrorInMini from './handleAuthErrorInMini';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { onBootError } from './onBootError';
import { updateServiceConfig } from 'owa-service/lib/config';

let isErrorAlreadyHandled: boolean;
function handleDataError(
    onAuthFailure: ((claimsChallenge: string | null) => boolean) | undefined,
    responseHeaders: Headers,
    onlyHandleFirstAuthError: boolean = true
) {
    if (onlyHandleFirstAuthError) {
        if (isErrorAlreadyHandled) {
            return;
        }

        isErrorAlreadyHandled = true;
    }

    handleAuthErrorInMini(getHostLocation(), onAuthFailure, responseHeaders);
}

export function updateBaseUrlAndHandleAuthError(sessionPromise: Promise<any>) {
    sessionPromise?.catch(onBootError);
    updateServiceConfig({
        baseUrl: getScopedPath('/owa'),
        onAuthNeeded: async responseHeaders => {
            handleDataError(() => false, responseHeaders);
        },
    });
}
